import { ThemeEvents } from '@theme/events';

class CartIcon extends HTMLElement {
  constructor() {
    super();
    this.cartDrawer = null;
    this.cartCount = null;
    this.addToCartBehavior = null;
  }

  connectedCallback() {
    if (document.querySelector('[data-ref="cart-drawer"]')) {
      this.cartDrawer = document.querySelector('[data-ref="cart-drawer"]');
    }

    this.addToCartBehavior = this.dataset.addToCartBehavior || 'open_cart';

    this.cartCount = this.querySelector('[data-ref="cart-count"]');

    this.addEventListener('click', this.handleClick.bind(this));
    document.addEventListener(ThemeEvents.cartUpdated, this.onCartUpdated.bind(this));
  }

  disconnectedCallback() {
    document.removeEventListener(ThemeEvents.cartUpdated, this.onCartUpdated.bind(this));
    this.removeEventListener('click', this.handleClick.bind(this));
  }

  getCurrentItemCount() {
    return parseInt(this.cartCount.textContent);
  }

  onCartUpdated(event) {
    this.cartCount.textContent = event.detail.data.itemCount;
    if (this.addToCartBehavior == 'open_cart') this.openCart();

    setTimeout(() => {
      this.ensureCartCountIsCorrect();
    }, 100);
  }

  ensureCartCountIsCorrect() {
    let cartCount = 0;
    if (document.querySelector('[data-ref="cart-drawer"]')) {
      const cartItems = document.querySelector('[data-ref="cart-drawer"]').querySelectorAll('[data-ref="cart-item"]');
      cartItems.forEach((cartItem) => {
        cartCount += parseInt(cartItem.querySelector('[data-ref="quantity-selector-input"]').value);
      });
    }

    if (cartCount != this.getCurrentItemCount()) {
      this.cartCount.textContent = cartCount;
    }
  }

  handleClick() {
    this.openCart();
  }

  openCart() {
    if (this.cartDrawer) {
      this.cartDrawer.open();
    } else {
      window.location.href = Theme.routes.cart_url;
    }
  }
}

if (!customElements.get('cart-icon')) {
  customElements.define('cart-icon', CartIcon);
}
